import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { AddRotationAction, GenerateRotationsAction, GetRotationByStationAction, GetRotationsAction, GetRotationsStationsAction, GetRotationsStationsByExamAction, GetRotationsTrackAction, GetRotationsTracksAction, GetStationsByTrackAction, RotationsAction } from './rotations.actions';
import { LoadingState } from '@tsin-core/entities';
import { RotationService } from '@tsin-core/services/http/rotation.service';
import { catchError, tap } from 'rxjs';
import { RotationStation, TrackRotation } from '@tsin-core/models/rotations.model';

export class RotationsStateModel {
  public rotations!: any[];
  public tracks!: any[];
  public examinerStations!: any[]
  public rotationStations!: RotationStation[]
  public selectedRotations!: RotationStation[]
  public singleTrack!: TrackRotation;
  public loading!: LoadingState;
}

const defaults = {
  rotations: [],
  tracks: [],
  examinerStations: [],
  rotationStations: [],
  selectedRotations: [],
  singleTrack: null as unknown as TrackRotation,
  loading: LoadingState.notLoading,
};

@State<RotationsStateModel>({
  name: 'rotationsState',
  defaults
})

@Injectable()
export class RotationsState {

  rotationService: RotationService = inject(RotationService);

  @Selector()
  static getRotations(state: RotationsStateModel) {
    return state.rotations;
  }


  @Selector()
  static getTracks(state: RotationsStateModel) {
    return state.tracks;
  }

  @Selector()
  static getExmainerStations(state: RotationsStateModel) {
    return state.examinerStations;
  }


  @Selector()
  static getSingleTrack(state: RotationsStateModel) {
    return state.singleTrack;
  }


  @Selector()
  static getRotationStations(state: RotationsStateModel) {
    return state.rotationStations;
  }

  @Selector()
  static getSelectedRotations(state: RotationsStateModel) {
    return state.selectedRotations;
  }


  @Selector()
  static getLoading(state: RotationsStateModel) {
    return state.loading;
  }

  @Action(RotationsAction)
  add({ getState, setState }: StateContext<RotationsStateModel>, { payload }: RotationsAction) {
    const state = getState();
    // setState({ items: [...state.items, payload] });
  }

  @Action(GetRotationsAction)
  getRotations(ctx: StateContext<RotationsStateModel>, action: GetRotationsAction) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.rotationService.getRotations(action.payload).pipe(
      tap((rotationResponse: any[]) => {
        console.log('Get Rotations', rotationResponse)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          rotations: rotationResponse,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(GetRotationsTrackAction)
  getRotationTrack(ctx: StateContext<RotationsStateModel>, action: GetRotationsTrackAction) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.rotationService.getRotationsTrack(action.payload).pipe(
      tap((singleTrackResponse: TrackRotation) => {
        console.log('Get Rotations Tracks', singleTrackResponse)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          singleTrack: singleTrackResponse,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }



  @Action(GetRotationsTracksAction)
  getRotationTracks(ctx: StateContext<RotationsStateModel>, action: GetRotationsTracksAction) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.rotationService.getRotationsTracks(action.payload).pipe(
      tap((tracksResponse: any[]) => {
        console.log('Get Rotations Tracks', tracksResponse)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          tracks: tracksResponse,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(GetRotationsStationsAction)
  getRotationStations(ctx: StateContext<RotationsStateModel>, action: GetRotationsStationsAction) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.rotationService.getRotationStations(action.payload).pipe(
      tap((rotationResponse: any[]) => {
        console.log('Get Rotations Stations', rotationResponse)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          rotations: rotationResponse,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(GetRotationsStationsByExamAction)
  getRotationStationsByExam(ctx: StateContext<RotationsStateModel>, action: GetRotationsStationsByExamAction) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.rotationService.getRotationStationsByExam(action.payload).pipe(
      tap((examinerStationsResponse: any[]) => {
        console.log('Get Rotations Stations By Exam', examinerStationsResponse)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          examinerStations: examinerStationsResponse,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(GetStationsByTrackAction)
  getStationsByTrack(ctx: StateContext<RotationsStateModel>, action: GetStationsByTrackAction) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.rotationService.getStationsByTrack(action.payload).pipe(
      tap((rotationStationsResponse: any[]) => {
        console.log('Get Stations By Track', rotationStationsResponse)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          rotationStations: rotationStationsResponse,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(GetRotationByStationAction)
  getStationsByStation(ctx: StateContext<RotationsStateModel>, action: GetRotationByStationAction) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.rotationService.getRotationsByStation(action.payload).pipe(
      tap((rotationStationResponse: any[]) => {
        console.log('Get Rotations By Station', rotationStationResponse)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          rotationStations: rotationStationResponse,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

  @Action(GenerateRotationsAction)
  generateRotations(ctx: StateContext<RotationsStateModel>, action: GenerateRotationsAction) {
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.rotationService.generateStations(action.payload).pipe(
      tap((newExamPool: any) => {

        console.log('generate Rotations', newExamPool)
        const state = ctx.getState();
        ctx.patchState({
          // exams: [...state.exams, newExamPool],
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }


  @Action(AddRotationAction)
  addNewRotation(ctx: StateContext<RotationsStateModel>, action: AddRotationAction) {
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.rotationService.addNewRotation(action.payload).pipe(
      tap((newRotation: any) => {
        const state = ctx.getState();
        ctx.patchState({
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

}
